import React, { Component } from "react"

const BILLING_SETTINGS_PAYMENT_TEXT = "Payment Method"
const BILLING_SETTING_UPDATE_PAYMENT_BUTTON = "Update Credit Card"
const BILLING_SETTING_UPGRADE_PAYMENT_BUTTON = "Upgrade Now"
const BILLING_SETTING_EXPIRATION_TEXT = "Expiration"

class BillingSettingsCardInfo extends Component {
    constructor(props) {
        super(props)
    }

    renderCreditCardInfo = () => {
        const {
            customer: { ccBrand, ccLast4, ccExpDate, paymentStatus },
        } = this.props
        const isPaymentCancelled =
            paymentStatus === "cancelled"
                ? "billing-settings-plan-card-info-cancelled"
                : "billing-settings-plan-card-info"

        const ccNumberString = ccLast4 ? ccLast4 : ""

        return (
            <div className={isPaymentCancelled}>
                <p className="admin-billing-info-plan">
                    {`${ccBrand} **** **** **** ${ccNumberString}`}
                </p>
                <div className="admin-billing-expiration-containter">
                    <p>
                        {BILLING_SETTING_EXPIRATION_TEXT}:{" "}
                    </p>
                    <p>
                        <span className="admin-billing-info-plan">{ccExpDate}</span>
                    </p>
                </div>
            </div>
        )
    }

    render() {
        const {
            customer,
            customer: { paymentStatus, trialEnd },
            setPaymentModalOpen,
        } = this.props

        const isFreeTrial = !!trialEnd
        return (
            <div className="billing-settings-plan-container">
                <p className="billing-overview-section-title">
                    {BILLING_SETTINGS_PAYMENT_TEXT}
                </p>
                {!!customer.id && this.renderCreditCardInfo()}
                {paymentStatus === "paid" || isFreeTrial ? (
                    <div className="billing-button-container">
                        <button
                            onClick={setPaymentModalOpen}
                            className="btn btn-primary billing-info-button"
                        >
                            {isFreeTrial
                                ? BILLING_SETTING_UPGRADE_PAYMENT_BUTTON
                                : BILLING_SETTING_UPDATE_PAYMENT_BUTTON}
                        </button>
                    </div>
                ) : (
                    <div className="hide-button-2" />
                )}
            </div>
        )
    }
}

export default BillingSettingsCardInfo



// WEBPACK FOOTER //
// ./src/components/billing_settings_card_info.jsx